<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="4">
        <Notification 
          v-for="notification in notifications.notifications"
          :key="notification.id"
          :notification="notification"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Notification from "@/components/Notification";
import { mapState } from "vuex";
export default {
  components: {
    Notification
  },
  computed: mapState(["notifications"])
}
</script>